import { render, staticRenderFns } from "./OtherCircumstancesFS.vue?vue&type=template&id=55740a6a"
import script from "./OtherCircumstancesFS.vue?vue&type=script&lang=ts"
export * from "./OtherCircumstancesFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports